(() => {
  'use strict';
  if (window.DelugsLugAnalytics) return;
  const events = new Set(['lug_tool_help_view', 'lug_tool_open_pdp', 'lug_tool_view', 'lug_tool_started', 'lug_tool_calibrated', 'lug_tool_card_calibrated', 'lug_tool_preset_calibrated', 'lug_tool_straps_view', 'lug_tool_ruler_view', 'lug_tool_recalibrate']);
  const sent = new Set();
  const pending = new Set();
  const visible = new Map();
  let timer;
  let retries = 0;
  const production = () => window.Shopify?.theme?.role === 'main' && !window.Shopify?.designMode;
  const allowed = () => {
    try { return production() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  function flush() {
    clearTimeout(timer);
    if (!allowed()) { pending.clear(); return; }
    if (typeof window.gtag !== 'function') {
      if (pending.size && retries++ < 20) timer = setTimeout(flush, 500);
      return;
    }
    for (const event of pending) {
      try {
        // Reuse the store's configured Google tag; never send these events to its Ads destinations.
        window.gtag('event', event, {send_to:'G-R92578CT0B', tool_version:'1', transport_type:'beacon'});
        sent.add(event);
        pending.delete(event);
      } catch (_) { /* Analytics must never interrupt measurement or navigation. */ }
    }
  }
  function track(event) {
    // At most once per event per page. No card data, measured width, customer data, or new identifiers.
    if (!events.has(event) || sent.has(event) || pending.has(event) || !allowed()) return;
    pending.add(event);
    retries = 0;
    flush();
  }
  window.DelugsLugAnalytics = Object.freeze({track});
  function trackVisible() {
    for (const [target, event] of visible) {
      const rect = target.getBoundingClientRect();
      if (rect.width && rect.height && rect.top < innerHeight && rect.bottom > 0) track(event);
    }
  }
  function refreshConsent() {
    if (!allowed()) { pending.clear(); clearTimeout(timer); return; }
    flush();
    trackVisible();
  }
  function initialise() {
    if (!production()) return;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          visible.set(entry.target, 'lug_tool_view');
          track('lug_tool_view');
        } else visible.delete(entry.target);
      }
    }, {threshold:0.5});
    document.querySelectorAll('[data-screen-ruler] .dlr__header').forEach(target => observer.observe(target));
    document.querySelectorAll('[data-lug-width-screen-help]').forEach(target => {
      const modal = target.closest('modal-dialog');
      if (!modal) return;
      const update = () => {
        if (modal.hasAttribute('open')) { visible.set(target, 'lug_tool_help_view'); track('lug_tool_help_view'); }
        else visible.delete(target);
      };
      // Closed Shopify modals still have layout boxes; IntersectionObserver alone counts false views.
      new MutationObserver(update).observe(modal, {attributes:true,attributeFilter:['open']});
      update();
    });
    document.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('[data-lug-width-screen-help] a.dlr-pdp-help__link')) track('lug_tool_open_pdp');
    });
    document.addEventListener('visitorConsentCollected', refreshConsent);
    window.addEventListener('load', refreshConsent, {once:true});
    if (!window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) refreshConsent(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
})();
